module.exports = __webpack_public_path__ + "images/moonshot/background-left.0981646ebe35ae467171.svg";